<div class="not-found-container">
  <span>We are</span>
  <img src="assets/img/vx-anagrama.png">
  <h2>{{ '{ four.zero.four }' }}<br>page not found</h2>
</div>
